import { render, staticRenderFns } from "./payment_breakdown.vue?vue&type=template&id=2ee1532a&scoped=true&"
import script from "./payment_breakdown.vue?vue&type=script&lang=js&"
export * from "./payment_breakdown.vue?vue&type=script&lang=js&"
import style0 from "./payment_breakdown.vue?vue&type=style&index=0&id=2ee1532a&scoped=true&lang=css&"
import style1 from "./payment_breakdown.vue?vue&type=style&index=1&id=2ee1532a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee1532a",
  null
  
)

export default component.exports